import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const UserManagement = () => {
    const [users, setUsers] = useState([]);
    const [newUser, setNewUser] = useState({ username: '', password: '', role: 'user' });
    const [message, setMessage] = useState('');

    useEffect(() => {
        loadUsers();
    }, []);

    const loadUsers = async () => {
        try {
            const response = await api.getUsers();
            setUsers(response.data);
        } catch (error) {
            setMessage('Ошибка загрузки пользователей');
        }
    };

    const handleCreateUser = async (e) => {
        e.preventDefault();
        try {
            await api.createUser(newUser);
            setMessage('Пользователь создан успешно');
            setNewUser({ username: '', password: '', role: 'user' });
            loadUsers();
        } catch (error) {
            setMessage('Ошибка создания пользователя');
        }
    };

    const handleDeleteUser = async (userId, username, role) => {
        if (role === 'admin') {
            setMessage('Нельзя удалить администратора');
            return;
        }

        if (!window.confirm(`Вы уверены, что хотите удалить пользователя ${username}?`)) {
            return;
        }

        try {
            await api.deleteUser(userId);
            setMessage('Пользователь удален успешно');
            loadUsers();
        } catch (error) {
            setMessage('Ошибка удаления пользователя');
        }
    };

    return (
        <div className="user-management">
            <h3>Управление пользователями</h3>
            
            <form onSubmit={handleCreateUser} className="user-form">
                <input
                    type="text"
                    placeholder="Логин"
                    value={newUser.username}
                    onChange={(e) => setNewUser({...newUser, username: e.target.value})}
                    required
                />
                <input
                    type="password"
                    placeholder="Пароль"
                    value={newUser.password}
                    onChange={(e) => setNewUser({...newUser, password: e.target.value})}
                    required
                />
                <select
                    value={newUser.role}
                    onChange={(e) => setNewUser({...newUser, role: e.target.value})}
                >
                    <option value="user">Гость</option>
                    <option value="lawyer">Юрист</option>
                    <option value="accountant">Бухгалтер</option>
                    <option value="admin">Администратор</option>
                </select>
                <button type="submit">Создать пользователя</button>
            </form>

            {message && <div className="message">{message}</div>}

            <div className="users-list">
                <h4>Список пользователей:</h4>
                {users.map(user => (
                    <div key={user.id} className="user-item">
                        <span>{user.username} - {user.role}</span>
                        {user.role !== 'admin' && (
                            <button 
                                onClick={() => handleDeleteUser(user.id, user.username, user.role)}
                                style={{
                                    marginLeft: '1rem',
                                    padding: '0.25rem 0.5rem',
                                    backgroundColor: '#e74c3c',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                Удалить
                            </button>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default UserManagement;